import styled from 'styled-components'

export const StyledContainer = styled.div`
  max-width: 1000px;
  margin-top: 50px;
  margin-bottom: 50px;
`

export const StyledAccordionList = styled.div`
  margin: 20px auto 0;

  ${({ theme }) => theme.media.up.lg} {
    margin-left: 30px;
  }
`

export const StyledAccordionLotSymbols = styled.div`
  td {
    padding-left: 3px;
    padding-right: 3px;
    padding-top: 3px;
    vertical-align: middle;
    min-width: 45px;
  }
`
